import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { Modal } from "../../../theme/Component/Modal";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _EmployeeBenefit, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { useEffect, useState } from "react";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import usePaginator from "../../../theme/Component/usePaginator";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { CountriesEditor } from "../../../Inventories-Warehouses/Product/Countries/CountriesEditor";
import { DropDown } from "../../../theme/Component/DropDown";


interface ComponentData {
    isModal?: boolean;
    _onChange?: Function;
}

export const EmployeeBenefit = ({ isModal, _onChange }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista, validateForm, isMissing, isRequired } = useDataBean(_EmployeeBenefit);
    const paginator = usePaginator();

    const [regex, setRegex] = useState<string>("");
    const [idCountrie, setIDCountrie] = useState<number | null>();

    const modal = useModal("", MODAL_md);
    const modalEdit = useModal("", MODAL_md);

    const hasDocumentType = (value: number | null | undefined): value is number => value !== null && value !== undefined;

    const getCountryLabel = (item: any) => {
        return [item?.CountryISO3, item?.CountryName].filter(Boolean).join(" - ");
    }

    useEffect(() => {
        if (!hasDocumentType(idCountrie)) {
            toast.info("Se debe seleccionar un País")
            return;
        }
        getLista();
    }, [paginator.page])

    const getLista = () => {
        if (!hasDocumentType(idCountrie)) {
            return;
        }

        instance.getEmployeeBenefitCatalog(idCountrie, regex != "" ? regex : null, paginator.page, 15).then(
            (resp: any) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List?.map((item: any) => {
                    const properties = item?.DataBeanProperties ?? {};
                    return {
                        ...item,
                        DataBeanProperties: {
                            ...properties,
                            Country: getCountryLabel(properties),
                        }
                    }
                }) ?? []);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Tipos de Beneficios de Empleados");
        });
    };

    const head = [
        { title: 'ID', property: 'IDEmployeeBenefit', visible: true },
        { title: 'País', property: 'Country', visible: true },
        { title: 'Código', property: 'Mnemonic', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Clase Liquidador', property: 'ClassForName', visible: true },
        { title: 'Clase Liquidador Local', property: 'LocalClassForName', visible: true },
    ];

    const updateBenefits = () => {
        instance.updatetEmployeeBenefitsForCountry(idCountrie).then(
            (resp) => {
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    const actionsDropDown = [
        { id: 1, name: 'Actualizar Beneficios a Empleados por País', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={buttonEvent}></DropDown>
                </div>
            </div>
        )
    }

    const buttonEvent = (e) => {
        if (e.id === 1) {
            modal.open(`Actualizar Beneficios a Empleados por País`);
        }
    }

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan campos obligatorios por diligenciar");
            return;
        }

        instance.updateEmployeeBenefit(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.open(`Tipos de Beneficio de Empleado ${bean.Name}`) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setValue = (e: any) => {
        _onChange?.(e);
        setBean(e);
    }

    const baseComponent = () => {
        return (
            <>
                <div className="row">
                    <div className="col-md-6">
                        <CountriesEditor idSelector={idCountrie} onChange={(e) => { setIDCountrie(e) }} label="País" />
                    </div>
                    <div className="col-md-6">
                        <label>Busqueda por Texto</label>
                        <input type="text" className="form-control" value={regex} onChange={(e) => { setRegex(e.target.value) }} />
                    </div>
                    <div className="col-md-6">
                        <BasicButton icon="ri-seach-line" useMargin eventClick={() => {
                            if (!hasDocumentType(idCountrie)) {
                                toast.info("Se debe seleccionar un País")
                                return;
                            }
                            getLista();
                        }}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setValue} headButtons={buttons()} records={paginator} />
                    </div>

                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${isMissing('LocalClassForName') ? 'has-error' : ''}`} >Clase Liquidador Local {isRequired('LocalClassForName') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.LocalClassForName} onChange={(e) => { setBean({ ...bean, LocalClassForName: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { updateBenefits() }} onSubmitLabel="Actualizar" >
                        Actualizar Beneficios de Empelados por pais?
                    </Modal>

                </div>
            </>
        )

    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Tipos de Beneficios de Empleados">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}
